import { set } from "@/utils/vuex";

export default {
  resetState(state) {
    if (state) {
      Object.assign(state, state.getDefaultState());
    }
  },
  setEmail: set("email"),
  setName: set("name"),
  setLoading: set("loading"),
  setFilter: set("filter"),
  setUsers: set("users"),
  setPartners: set("partners"),
  setRecipients: set("recipients"),
  setPlants: set("plants"),
  setSplits: set("splits"),
  setContracts: set("contracts"),
  setPlans: set("plans"),
  setBanks: set("banks"),
  setUser: set("user"),
  setTabulations: set("tabulations"),
  setUrlShortners: set("urlShortners"),
  setUtilityCompanies: set("utilityCompanies"),
  setCooperatives: set("cooperatives"),
  setHolidays: set("holidays"),

  setPartnerDialog: set("partnerDialog"),
  setRecipientDialog: set("recipientDialog"),
  setPowerPlantDialog: set("powerPlantDialog"),
  setSplitDialog: set("splitDialog"),
  setPowerPlantContractsList: set("powerPlantContractsList"),
  setDocuments: set("documents"),

  pushUser(state, data) {
    state.users.push(data);
  },
  spliceUsers(state, { index, data }) {
    state.users.splice(index, 1, data);
  },
  pushPartner(state, data) {
    state.partners.push(data);
  },
  splicePartners(state, { index, data }) {
    state.partners.splice(index, 1, data);
  },
  pushRecipient(state, data) {
    state.recipients.push(data);
  },
  spliceRecipients(state, { index, data }) {
    state.recipients.splice(index, 1, data);
  },
  pushPlant(state, data) {
    state.plants.push(data);
  },
  pushPlan(state, data) {
    state.plans.push(data);
  },
  pushContracts(state, data) {
    state.contracts.push(data);
  },
  splicePlants(state, { index, data }) {
    state.plants.splice(index, 1, data);
  },
  pushSplit(state, data) {
    state.splits.push(data);
  },
  splicePlans(state, { index, data }) {
    state.plans.splice(index, 1, data);
  },
  addBanckAccountInPartner(state, data) {
    state.partner.bankAccounts.push(data);
  },
  pushTabulations(state, data) {
    state.tabulations.push(data);
  },
  spliceTabulations(state, { index, data }) {
    state.tabulations.splice(index, 1, data);
  },
  pushUrlShortners(state, data) {
    state.urlShortners.push(data);
  },
  unshiftUrlShortners(state, data) {
    state.urlShortners.unshift(data);
  },
  spliceUrlShortners(state, { index, data }) {
    state.urlShortners.splice(index, 1, data);
  },
  pushUtilityCompany(state, data) {
    state.utilityCompanies.push(data);
  },
  spliceUtilityCompanies(state, { index, data }) {
    state.utilityCompanies.splice(index, 1, data);
  },
  pushCooperative(state, data) {
    state.cooperatives.push(data);
  },
  spliceCooperatives(state, { index, data }) {
    state.cooperatives.splice(index, 1, data);
  },
  pushHoliday(state, data) {
    state.holidays.push(data);
  },
  spliceHolidays(state, { index, data }) {
    state.holidays.splice(index, 1, data);
  },
};
